var _path, _path2, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5C39",
    d: "M50.001,0C22.385,0,0,22.388,0,50c0,0.28,0.016,0.554,0.021,0.83l48.719,2.079L29.154,95.446 C35.5,98.362,42.559,100,50.001,100C77.611,100,100,77.615,100,50C100,22.388,77.611,0,50.001,0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -683.4551,
    y1: 623.7627,
    x2: -650.1886,
    y2: 657.0292,
    gradientTransform: "matrix(1 0 0 -1 694 705)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF5C39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#485CC7"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M22.42,37.705L0.021,50.83c0.323,19.814,12.168,36.818,29.133,44.617L48.74,83.975V52.9L22.42,37.705 z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "22.42,37.705 48.74,52.909 48.74,83.975 93.52,25.337 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcaLogo);
export default __webpack_public_path__ + "static/media/proca-logo.c75f2188d556ac86b611b19b6bce9b63.svg";
export { ForwardRef as ReactComponent };